"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src2730718938/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .bottom {\n    display: flex;\n    width: 100%;\n    \n    .main-content {\n      width: 100%;\n    }\n  } \n  .sidebar {\n    width: 274px;\n    \n    @media screen and (max-width: ", "px) {\n      display: ", "}}\n"])), _breakpoints.default.mobile, function (props) {
  if (props.hideSidebarOnMobile) {
    return 'none';
  }
  return 'block';
});
var Layout = function Layout(_ref) {
  var _ref$header = _ref.header,
    header = _ref$header === void 0 ? false : _ref$header,
    _ref$sidebar = _ref.sidebar,
    sidebar = _ref$sidebar === void 0 ? false : _ref$sidebar,
    children = _ref.children,
    _ref$hideSidebarOnMob = _ref.hideSidebarOnMobile,
    hideSidebarOnMobile = _ref$hideSidebarOnMob === void 0 ? true : _ref$hideSidebarOnMob;
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: "main-layout",
    hideSidebarOnMobile: hideSidebarOnMobile
  }, header ? /*#__PURE__*/_react.default.createElement("header", {
    className: "header"
  }, header) : false, /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom"
  }, /*#__PURE__*/_react.default.createElement("main", {
    className: "main-content"
  }, children), sidebar ? /*#__PURE__*/_react.default.createElement("aside", {
    className: "sidebar",
    "aria-label": "\u05D8\u05D5\u05E4\u05E1 \u05D4\u05E9\u05D0\u05E8\u05EA \u05E4\u05E8\u05D8\u05D9\u05DD \u05DC\u05D7\u05D6\u05E8\u05D4 \u05DE\u05E0\u05E6\u05D9\u05D2 \u05D1\u05D8\u05DC\u05E4\u05D5\u05DF"
  }, sidebar) : false));
};
Layout.propTypes = {
  children: _propTypes.default.any,
  header: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node]),
  hideSidebarOnMobile: _propTypes.default.bool,
  sidebar: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node])
};
var _default = exports.default = Layout;